import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg viewBox="0 0 150 150" {...props}>
    <g fill="none" fillRule="evenodd">
      <g fill="#51565C" fillRule="nonzero">
        <path d="M52.875 37.44l1.882 2.952c14.715-9.382 34.001-8.268 47.58 3.126 17.054 14.31 19.279 39.737 4.968 56.792-.333.396-.672.785-1.018 1.167l2.594 2.35c.376-.415.744-.837 1.105-1.268 15.553-18.535 13.136-46.17-5.4-61.723-14.757-12.382-35.717-13.593-51.71-3.395z" />
        <path d="M105.575 91.261l-2.774.58 2.718 12.564a1.426 1.426 0 0 0 1.536 1.116l12.789-1.297-.306-2.818-11.515 1.167-2.448-11.312zM99.008 111.89l-1.774-3.017c-14.589 8.578-33.174 7.178-46.35-3.88-17.055-14.31-19.28-39.736-4.97-56.791.333-.397.673-.786 1.019-1.168l-2.595-2.35c-.375.415-.744.838-1.104 1.268-15.554 18.536-13.136 46.17 5.4 61.723 14.32 12.017 34.517 13.538 50.374 4.215z" />
        <path d="M46.64 58.607l2.775-.58-2.718-12.564a1.426 1.426 0 0 0-1.536-1.116l-12.789 1.297.306 2.818 11.515-1.168 2.448 11.313z" />
      </g>
      <path
        fill="#51565C"
        fillRule="nonzero"
        d="M74.606 72.734l14.167-26.257 2.015 1.102-14.2 26.318c.35.478.557 1.066.557 1.703a2.889 2.889 0 0 1-2.886 2.886 2.889 2.889 0 0 1-2.886-2.886 2.889 2.889 0 0 1 3.233-2.866z"
      />
      <path fill="#7BB835" d="M70.822 43.105h6.76v7.347h-6.76z" />
      <path fill="#15539F" d="M70.822 98.938h6.76v7.346h-6.76z" />
      <path fill="#53A2D9" d="M45.132 70.532h6.76v7.346h-6.76zM96.962 70.532h6.76v7.346h-6.76z" />
    </g>
  </Svg>
)
